import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";

const Footer = () => {
  const location = useLocation();
  let { account } = useWeb3React();
  return (
    <>
      <section className="footermain">
        <Link
          to="/"
          className={
            location.pathname === "/" ? "innerlink active" : "innerlink"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            className="mainlinksvg"
          >
            <path
              d="M18.75 26.25V16.25C18.75 15.9185 18.6183 15.6005 18.3839 15.3661C18.1495 15.1317 17.8315 15 17.5 15H12.5C12.1685 15 11.8505 15.1317 11.6161 15.3661C11.3817 15.6005 11.25 15.9185 11.25 16.25V26.25"
              stroke="#75768F"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.75 12.5C3.74991 12.1363 3.82917 11.777 3.98223 11.4471C4.1353 11.1173 4.3585 10.8247 4.63625 10.59L13.3862 3.08999C13.8375 2.70862 14.4092 2.49939 15 2.49939C15.5908 2.49939 16.1625 2.70862 16.6138 3.08999L25.3638 10.59C25.6415 10.8247 25.8647 11.1173 26.0178 11.4471C26.1708 11.777 26.2501 12.1363 26.25 12.5V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V12.5Z"
              stroke="#75768F"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="svgpara">Home</p>
        </Link>
        <Link
          to="/games"
          className={
            location.pathname === "/games" ? "innerlink active" : "innerlink"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            className="mainlinksvg"
          >
            <path
              d="M15 12.5H5C3.61929 12.5 2.5 13.6193 2.5 15V25C2.5 26.3807 3.61929 27.5 5 27.5H15C16.3807 27.5 17.5 26.3807 17.5 25V15C17.5 13.6193 16.3807 12.5 15 12.5Z"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.4 17.5L26.775 13.125C27.2388 12.6106 27.4955 11.9426 27.4955 11.25C27.4955 10.5574 27.2388 9.88938 26.775 9.375L20.525 3.225C20.0106 2.76121 19.3426 2.50452 18.65 2.50452C17.9574 2.50452 17.2894 2.76121 16.775 3.225L12.5 7.5"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.5 22.5H7.51167"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 17.5H12.5117"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.75 7.5H18.7617"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.5 11.25H22.5117"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="svgpara">Games</p>
        </Link>
        <Link
          to="/liquidity"
          className={
            location.pathname === "/liquidity"
              ? "innerlink active"
              : "innerlink"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            className="mainlinksvg"
          >
            <path
              d="M8.75 20.375C11.5 20.375 13.75 18.0875 13.75 15.3125C13.75 13.8625 13.0375 12.4875 11.6125 11.325C10.1875 10.1625 9.1125 8.4375 8.75 6.625C8.3875 8.4375 7.325 10.175 5.8875 11.325C4.45 12.475 3.75 13.875 3.75 15.3125C3.75 18.0875 6 20.375 8.75 20.375Z"
              stroke="#75768F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.7 8.24999C16.5597 6.8764 17.1692 5.3613 17.5 3.77499C18.125 6.89999 20 9.89999 22.5 11.9C25 13.9 26.25 16.275 26.25 18.775C26.2572 20.5029 25.7511 22.1939 24.796 23.6339C23.8409 25.0738 22.4798 26.1977 20.8852 26.8631C19.2906 27.5285 17.5343 27.7055 15.839 27.3716C14.1437 27.0377 12.5857 26.2079 11.3625 24.9875"
              stroke="#75768F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="svgpara">liquidity</p>
        </Link>
        <Link
          to="/options"
          className={
            location.pathname === "/options" ? "innerlink active" : "innerlink"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            className="mainlinksvg"
          >
            <path
              d="M17.5 21.25H6.25"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.75 8.75H12.5"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.25 25C23.3211 25 25 23.3211 25 21.25C25 19.1789 23.3211 17.5 21.25 17.5C19.1789 17.5 17.5 19.1789 17.5 21.25C17.5 23.3211 19.1789 25 21.25 25Z"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.75 12.5C10.8211 12.5 12.5 10.8211 12.5 8.75C12.5 6.67893 10.8211 5 8.75 5C6.67893 5 5 6.67893 5 8.75C5 10.8211 6.67893 12.5 8.75 12.5Z"
              stroke="#75768F"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="svgpara">Options</p>
        </Link>
        {account && (
          <Link
            to="/myprofile"
            className={
              location.pathname === "/myprofile"
                ? "innerlink active"
                : "innerlink"
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              className="mainlinksvg"
            >
              <path
                d="M23.75 26.25V23.75C23.75 22.4239 23.2232 21.1521 22.2855 20.2145C21.3478 19.2768 20.0761 18.75 18.75 18.75H11.25C9.92392 18.75 8.65215 19.2768 7.71447 20.2145C6.77678 21.1521 6.25 22.4239 6.25 23.75V26.25"
                stroke="#75768F"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15 13.75C17.7614 13.75 20 11.5114 20 8.75C20 5.98858 17.7614 3.75 15 3.75C12.2386 3.75 10 5.98858 10 8.75C10 11.5114 12.2386 13.75 15 13.75Z"
                stroke="#75768F"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p className="svgpara">Profile</p>
          </Link>
        )}
      </section>
    </>
  );
};

export default Footer;